export default {
    ThisDay: 20,
    ThisWeek: 30,
    ThisMonth: 45,
    ThisYear: 500,
    Custom: 999,
};
